import * as React from 'react'
import { SVGProps } from 'react'
import PropTypes from 'prop-types'
interface SVGRProps {
    title?: string;
    titleId?: string;
}
function SvgHandshakeFill({
    title,
    titleId,
    ...props
}: SVGProps<SVGSVGElement> & SVGRProps) {
    return (
        <svg
            viewBox="0 0 48 48"
            fill="currentColor"
            xmlns="http://www.w3.org/2000/svg"
            aria-labelledby={titleId}
            {...props}
        >
            {title ? <title id={titleId}>{title}</title> : null}
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M35.31 15.82h6.684c.526 0 .955.423.955.948v11.447c0 .525-.43.955-.955.955H36.17a3.782 3.782 0 0 0-1.325-2.262l-8.69-7.054 1.558-1.426a.954.954 0 1 0-1.29-1.409l-1.61 1.474-3.164 2.895a.03.03 0 0 1-.012.006c-.004.001-.009.003-.012.006-1.259 1.128-2.775.465-3.348-.162a2.369 2.369 0 0 1 .126-3.342.08.08 0 0 0 .009-.012l.009-.012 5.866-5.37a1.909 1.909 0 0 1 1.29-.502h5.126c.507 0 .99.203 1.349.56l3.258 3.26ZM24.724 21.16l8.91 7.234c.818.668.943 1.868.275 2.691l-.567.698a1.907 1.907 0 0 1-2.686.28l-.322-.262-1.874 2.304a2.218 2.218 0 0 1-3.121.322l-1.069-.925-.011.012a3.819 3.819 0 0 1-5.372.555l-5.4-4.888H5.71a.958.958 0 0 1-.955-.954V16.774c0-.525.43-.955.955-.955h6.684l3.265-3.259a1.907 1.907 0 0 1 1.348-.56h5.002l-4.882 4.47a4.3 4.3 0 0 0-.263 6.069c.89.973 3.647 2.477 6.07.262l1.79-1.64Z"
                fill="#297A71"
            />
        </svg>
    )
}
SvgHandshakeFill.propTypes = {
    title: PropTypes.string,
    fill: PropTypes.string,
    width: PropTypes.string,
    height: PropTypes.string,
    stroke: PropTypes.string,
    color: PropTypes.string,
}
export default SvgHandshakeFill
